/**
 * Requires
 */

import $ from 'jquery'
import objectFitPolyfill from 'objectFitPolyfill'
window.jQuery = $

/**
 * Modules
 */

import * as Svg from './svg'
import * as LazyLoad from './lazyload'
import * as Toggle from './toggle'
import * as SmoothScroll from './smooth-scroll'
import * as VideoEmbed from './video-embed'
import * as ExternalLinks from './external-links'
import * as Menu from './menu'
import * as Tessitura from './tessitura'
import * as FacebookPixel from './facebook-pixel'
import * as GoogleAnalytics from './analytics'
import * as Carousel from './carousel'
import * as Slides from './slides'
import * as CalendarNavigation from './calendar-navigation'
import * as Shows from './shows'
import * as Acknowledgement from './acknowledgment'
import * as Alert from './alert'
import * as Search from './search'
import * as Accordion from './accordion'

/**
 * Initialisation
 */

Svg.initialise()
LazyLoad.initialise()
Toggle.initialise()
SmoothScroll.initialise()
VideoEmbed.initialise()
ExternalLinks.initialise()
Menu.initialise()
Tessitura.initialise()
FacebookPixel.initialise()
GoogleAnalytics.initialise()
Carousel.initialise()
Slides.initialise()
CalendarNavigation.initialise()
Shows.initialise()
Acknowledgement.initialise()
Alert.initialise()
Search.initialise()
Accordion.initialise()
